import { User, Mail, CircleDollarSign, ArrowUpRight, ShieldX, TrendingUp, CalendarClock, ChartNoAxesCombined } from "lucide-react";
import MiniChart from "./MiniChart";




function DashboardKPI({ wallet }) {
    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-4 gap-6">

            {/* Owner Card */}
            <div className="bg-white shadow-md rounded-xl p-5 flex flex-col justify-between hover:shadow-lg transition-all cursor-pointer">
                <div className="flex items-center gap-3">
                    <div className="flex items-center justify-center w-12 h-12 rounded-full bg-gradient-to-tr from-indigo-500 to-blue-500 text-white">
                        <User className="w-6 h-6" />
                    </div>
                    <div>
                        {/* <p className="text-sm text-gray-400 font-medium uppercase tracking-wide">Owner</p> */}
                        <h3 className="text-lg md:text-xl font-semibold">{wallet?.customer_name || "-"}</h3>
                        <p className="text-xs text-gray-400">{wallet?.email || "-"}</p>
                    </div>
                </div>
            </div>

            {/* Current Balance Card */}
            <div className="bg-white shadow-md rounded-xl p-5 flex flex-col justify-between hover:shadow-lg transition-all cursor-pointer">
                <div className="flex items-center gap-3">
                    <div className="flex items-center justify-center w-12 h-12 rounded-full bg-gradient-to-tr from-green-500 to-teal-500 text-white">
                        <CircleDollarSign className="w-6 h-6" />
                    </div>
                    <div>
                        <p className="text-sm text-gray-400 font-medium uppercase tracking-wide">Current Balance</p>
                        <h3 className="text-lg md:text-xl font-semibold">{wallet?.balance ?? "-"}</h3>

                    </div>
                </div>
            </div>

            {/* Total Transactions Card */}
            {/* <div className="bg-white shadow-md rounded-xl p-5 flex flex-col justify-between hover:shadow-lg transition-all cursor-pointer">
                <div className="flex items-center gap-3">
                    <div className="flex items-center justify-center w-12 h-12 rounded-full bg-gradient-to-tr from-purple-500 to-pink-500 text-white">
                        <ArrowUpRight className="w-6 h-6" />
                    </div>
                    <div>
                        <p className="text-sm text-gray-400 font-medium uppercase tracking-wide">Total Transactions</p>
                        <h3 className="text-lg md:text-xl font-semibold">{wallet?.total_transactions ?? 0}</h3>
                    </div>
                </div>
            </div> */}

            {/* 7-Day Balance Trend Card */}
            {/* <div className="bg-white shadow-md rounded-xl p-5 flex flex-col justify-between hover:shadow-lg transition-all cursor-pointer">
                <div className="flex items-center gap-3">
                  
                    <div className="flex items-center justify-center w-12 h-12 rounded-full bg-gradient-to-tr from-amber-500 to-orange-600 text-white">
                        <ChartNoAxesCombined className="w-6 h-6" />
                    </div>

                   
                    <div className="flex-1">
                        <p className="text-sm text-gray-400 font-medium uppercase tracking-wide">7-Day Balance Trend</p>
                        <div className="mt-2">
                            <MiniChart data={wallet?.last7days || []} />
                        </div>
                    </div>
                </div>
            </div> */}


            <div className="bg-white shadow-md rounded-xl p-5 flex flex-col justify-between hover:shadow-lg transition-all cursor-pointer">
                <div className="flex items-center gap-3">
                    {/* Icon */}
                    <div className="flex items-center justify-center w-12 h-12 rounded-full bg-gradient-to-tr from-emerald-500 to-teal-600 text-white">
                        <ArrowUpRight className="w-6 h-6" />
                    </div>

                    {/* Content */}
                    <div className="flex-1">
                        {/* <p className="text-sm text-gray-400 font-medium uppercase tracking-wide mb-2">
                            Total Credit vs Debit
                        </p> */}

                        {(() => {
                            const totalCredit = wallet?.footer?.credit_back || 0;
                            const totalDebit = wallet?.footer?.debit_back || 0;
                            const total = totalCredit + totalDebit;
                            const creditPercent = total ? (totalCredit / total) * 100 : 0;
                            const debitPercent = total ? (totalDebit / total) * 100 : 0;

                            return (
                                <>
                                    {/* Amounts */}
                                    <div className="flex justify-between text-sm font-semibold mb-1">
                                        <span className="text-green-600">${totalCredit.toFixed(2)}</span>
                                        <span className="text-red-500">${totalDebit.toFixed(2)}</span>
                                    </div>

                                    {/* Progress Bar */}
                                    <div className="w-full bg-gray-200 h-2 rounded-full overflow-hidden">
                                        <div
                                            className="h-2 bg-gradient-to-r from-green-500 to-green-400"
                                            style={{ width: `${creditPercent.toFixed(1)}%` }}
                                        ></div>
                                    </div>

                                    {/* Percentages */}
                                    <div className="flex justify-between text-xs text-gray-500 mt-1">
                                        <span>Credit {creditPercent.toFixed(1)}%</span>
                                        <span>Debit {debitPercent.toFixed(1)}%</span>
                                    </div>
                                </>
                            );
                        })()}
                    </div>
                </div>
            </div>


            <div className="bg-white shadow-md rounded-xl p-5 flex flex-col justify-between hover:shadow-lg transition-all cursor-pointer">
                <div className="flex items-center gap-3">
                    {/* Icon */}
                    <div className="flex items-center justify-center w-12 h-12 rounded-full bg-gradient-to-tr from-sky-500 to-indigo-500 text-white">
                        <CalendarClock className="w-6 h-6" />
                    </div>

                    {/* Content */}
                    <div className="flex-1">
                        <p className="text-sm text-gray-400 font-medium uppercase tracking-wide">Last Payment Date</p>
                        <div className="flex justify-between items-center">
                            <h3 className="text-lg md:text-xl font-semibold mt-1 text-gray-700">
                                {wallet?.last_transaction_date ? wallet.last_transaction_date.split(" ")[0] : "-"}
                            </h3>
                            <span className="text-xs text-gray-500 mt-0.5 font-mono">
                                {wallet?.last_transaction_date ? wallet.last_transaction_date.split(" ").slice(1).join(" ") : "-"}
                            </span>
                        </div>
                    </div>
                </div>
            </div>


        </div>
    );
}

export default DashboardKPI;
